export default "__VITE_ASSET__VLQd$ibE__"